import { render, staticRenderFns } from "./Dash-reach-body.vue?vue&type=template&id=288fd366"
import script from "./Dash-reach-body.vue?vue&type=script&lang=js"
export * from "./Dash-reach-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports